import React from 'react'

const WebDevLanding = () => {

  return (
    <div className="webdev_container">
            <div className="url_address">
                <h3>Home &gt; </h3>
                <h3>Expertise &gt; </h3>
                <h3>Web Development</h3>
            </div>
            <div className="webdev_landing">
                <div className="left_side">
                    <h1>Web Development</h1>
                    <h2>Sleek, Secure, Scalable, and High-Performance Websites.</h2>
                    <h3 className='left_side_text'>Creating stunning and functional websites that help businesses and individuals succeed online is what we do! Our team of skilled developers and designers work closely with clients to understand their needs and create customized solutions that are tailored to their specific requirements. With a focus on user experience and responsive design, we create websites that are not only visually appealing but also easy to navigate, fast-loading, and optimized for search engines.</h3>
                </div>
                <div className="right_side">
                    <img src='https://images.unsplash.com/file-1635995418779-976e1857a51aimage?dpr=2&auto=format&fit=crop&w=416&q=60' alt="image" />
                </div>
            </div>
        </div>
  )
}

export default WebDevLanding